import { axiosInterceptor } from "../authInterceptor";
import environment from "../../../../environments/environment";


const SAVE_THEME_URL= environment.postThemURL; 

export async function saveThemes(saveThemeVO: FormData) {
  try {
    // Do not set Content-Type header here, let Axios handle it automatically for FormData
    const response = await axiosInterceptor.post(`${SAVE_THEME_URL}`, saveThemeVO);
    return response;
  } catch (error) {
    console.error('There was an error saving the theme setting!', error);
    throw error;
  }
}

export async function getThemeDetails(todayDate: any,clientId: number) {
    try {
        const response = await axiosInterceptor.get(`${SAVE_THEME_URL}date/${todayDate}?clientId=${clientId}`); 
        return response;
    } catch (error: any) { 
        return error;
    } 
}